import script from "./TripsGlobe.vue?vue&type=script&setup=true&lang=js"
export * from "./TripsGlobe.vue?vue&type=script&setup=true&lang=js"

import "./TripsGlobe.vue?vue&type=style&index=0&id=474934f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-474934f4"]])

export default __exports__